import { render, staticRenderFns } from "./ChatAlert.vue?vue&type=template&id=746ef841&"
import script from "./ChatAlert.vue?vue&type=script&lang=js&"
export * from "./ChatAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports